// Landing hero: a crew of real GathrXR avatars (built with the in-app Meshy +
// Tripo pipeline). The others are posed stills; only the star (the founder's
// own avatar) moves, as a transparent video loop of a library dance. WebM VP9 carries alpha in Chrome/Edge/Firefox; Safari needs the
// HEVC-with-alpha .mov instead, so the source is picked per browser.
import React, { useMemo } from 'react';
import { useReducedMotion } from 'framer-motion';

const CREW = [
  { id: 'south-asian-woman', label: 'Priya' },
  { id: 'black-man', label: 'Marcus' },
  { id: 'me', label: 'aquariusmaximus', star: true },
  { id: 'latino-man', label: 'Diego' },
  { id: 'asian-woman', label: 'Mei' },
  { id: 'white-woman', label: 'Claire' },
];

// Served from R2, not Pages: iOS only plays <video> from servers that answer
// byte-range requests, and Cloudflare Pages always sends the whole file.
const VIDEO_ROOT = 'https://assets.gathrxr.com/landing/crew/v1/';

function useAlphaVideoExt(): 'mov' | 'webm' {
  return useMemo(() => {
    if (typeof navigator === 'undefined') return 'webm';
    const ua = navigator.userAgent;
    // Every iPhone/iPad browser (Chrome, Firefox, Instagram's in-app one…) is
    // WebKit underneath and shows WebM alpha as black, so they all get the .mov.
    const ios = /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
    const safari = /^((?!chrome|chromium|crios|fxios|android|edg).)*safari/i.test(ua);
    return ios || safari ? 'mov' : 'webm';
  }, []);
}

const HeroCrew: React.FC = () => {
  const ext = useAlphaVideoExt();
  const reduce = useReducedMotion();
  return (
    <div className="lx-crew" aria-hidden="true">
      <div className="lx-crew-floor" />
      {CREW.map((c, i) => (
        <figure key={c.id} className={`lx-crew-m lx-crew-${i}${c.star ? ' lx-crew-star' : ''}`}>
          <span className="lx-crew-tag">{c.label}</span>
          {reduce || !c.star ? (
            <img src={`/landing/crew/${c.id}.webp`} alt="" />
          ) : (
            <video
              src={`${VIDEO_ROOT}${c.id}.${ext}`}
              poster={`/landing/crew/${c.id}.webp`}
              autoPlay muted loop playsInline preload="auto"
            />
          )}
        </figure>
      ))}
    </div>
  );
};

export default HeroCrew;
